import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import './Modal.scss';

const Modal = ({
  children,
  isShown,
  title,
  onCloseInvoked,
}) => {
  const modalRef = useRef();
  const titleRef = useRef();
  const alertUser = (event) => {
    const confirmation = window.confirm('Unsaved work is still here, are you sure you want to reload?');
    if (!confirmation) {
      event.preventDefault();
      // eslint-disable-next-line no-param-reassign
      event.returnValue = '';
    }
  };
  const checkIfClickedOutside = (event) => {
    if (!modalRef.current || !titleRef.current) {
      return;
    }
    const insideBody = modalRef.current.contains(event.target);
    const insideHeader = titleRef.current.contains(event.target);
    if (!insideBody && !insideHeader && !event.target.className.includes(' modal ')) {
      if (onCloseInvoked) {
        onCloseInvoked();
      }
    }
  };
  const closeModal = () => {
    if (onCloseInvoked) {
      onCloseInvoked();
    }
  };
  useEffect(() => {
    window.addEventListener('beforeunload', alertUser);
    window.addEventListener('mousedown', checkIfClickedOutside);
    return () => {
      window.removeEventListener('beforeunload', alertUser);
      window.removeEventListener('mouseDown', checkIfClickedOutside);
    };
  }, []);
  return (
    <div className="modal-overlay">
      <div className={`modal-container ${isShown ? 'shown' : ''}`} ref={modalRef}>
        <div className="modal-title" ref={titleRef}>
          <h4>
            {title}
          </h4>
          <button type="button" title="close modal" onClick={closeModal}>
            <FontAwesomeIcon icon={solid('times')} />
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  isShown: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onCloseInvoked: PropTypes.func.isRequired,
};

export default Modal;
